

export class UpdateScheduleModel{
    TPLNumber : string;
    StatusCode : string;
    Location : string;
    SignalBy : string;
    Note : string;
    UpdatedWhen : string;
}